import React from 'react';
import { BILoggerStore } from '../../stores/BILoggerStore';
import { ConfigStore } from '../../stores/ConfigStore';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { HtmlHead } from '../HtmlHead/HtmlHead';
import { HeaderTitle } from '../HeaderTitle/HeaderTitle';
import { HeaderMenuPanel } from '../HeaderMenuPanel/HeaderMenuPanel';
import { TemplatesPage } from '../TemplatesPage/TemplatesPage';
import { SeoSection } from '../SeoSection/SeoSection';
import { MicroCategoriesTags } from '../MicroCategoriesTags/MicroCategoriesTags';
import { Description } from '../Description/Description';
import { SCROLL_TO_TOP_ID } from '../../utils/scrollToTop';
import { getBiElementData } from './getBiElementData';
import { appDataHooks } from './App.dataHooks';
import '../../styles/global.scss';

interface AppProps {
  biLoggerStore: BILoggerStore;
  configStore: ConfigStore;
}

const AppCmp = (props: AppProps) => {
  const { biLoggerStore, configStore } = props;
  const isEnabledMicroCategories = configStore.config.currentLanguage === 'en';

  React.useEffect(() => {
    const handler = (e: PointerEvent) => {
      biLoggerStore.logClickElement(getBiElementData(e.target as HTMLElement));
    };

    document.body.addEventListener('click', handler);
    return () => document.body.removeEventListener('click', handler);
  }, [biLoggerStore]);

  return (
    <div data-hook="app" id={SCROLL_TO_TOP_ID}>
      <HtmlHead />
      <HeaderTitle dataHook={appDataHooks.headerTitle()} />
      <HeaderMenuPanel dataHook={appDataHooks.headerMenuPanel()} />
      <TemplatesPage dataHook={appDataHooks.templatesPage()} />
      {isEnabledMicroCategories && <MicroCategoriesTags />}
      <SeoSection dataHook={appDataHooks.seoSection()} />
      <Description />
    </div>
  );
};

export const App = injectStoresV2('biLoggerStore', 'configStore')(AppCmp);
